package com.bikompanion.ui.mapper

/** What a bike's votes come to, as a fact rather than as copy. */
enum class BikeScoreVerdict {
    NoRatings,
    FewRatings,
    LooksGood,
    HasProblems,
    Mixed,
}
